import styles from "./styles.module.css"

export const Loader = ({ isVisible }: Props) => (
  isVisible ? (
    <div className={styles.wrapper}>
      <div className={styles.loader} />
    </div>
  ) : (
    <></>
  )
)

interface Props {
  isVisible: boolean;
}
